<h1 mat-dialog-title class="dialog-title-before-none">
  <!-- Group Name -->
  @if (true) {
    <div>
      @if (groupStack.length > 1) {
        <button mat-icon-button color="primary" aria-label="Back" (click)="onBackClick()">
          <mat-icon class="align-middle">arrow_back</mat-icon>
        </button>
      }
      @if (groupStack.length <= 1) {
        <button mat-icon-button color="primary" aria-label="Close" (click)="onCancelClick()">
          <mat-icon class="align-middle">close</mat-icon>
        </button>
      }
      @if (group.hasIdentifier && !!group.name) {
        <span>{{ 'GroupTitle' | translate: locale.language }}: {{ group.name }}</span>
      }
      @if (!group.hasIdentifier || !group.name) {
        <span>{{ 'GroupsTitle' | translate: locale.language }}</span>
      }
    </div>
  }
</h1>

<div mat-dialog-content style="min-height: 650px">
  <!-- Search field -->
  <mat-form-field
    appearance="outline"
    style="width: 100%"
    [style.visibility]="group.hasIdentifier ? 'hidden' : 'unset'">
    <mat-icon matIconPrefix class="align-middle">search</mat-icon>
    <mat-label for="qa-search-groups">{{ 'SearchGroups' | translate: locale.language }}</mat-label>
    <input matInput type="text" id="qa-search-groups" [formControl]="groupSearchControl" />
    @if (groupSearchControl.value) {
      <button
        matIconSuffix
        mat-icon-button
        [attr.aria-label]="'Clear' | translate: locale.language"
        (click)="groupSearchControl.setValue('')">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>

  <!-- Groups Loading Spinner -->
  <div style="min-height: 4px">
    <app-loading
      [isCircle]="false"
      [hasLoaded]="!!group.subgroups"
      [hasFailed]="loadGroupsFailed"
      (retryClicked)="loadGroupsPage()"></app-loading>
  </div>

  <!-- List of Groups -->
  @if (group.subgroups && group.subgroups.totalItemCount) {
    <div>
      <ul class="collection qa-group-collection" id="groupsList">
        @for (group of group.subgroups.items; track group.id) {
          <li
            app-selector-row
            id="groupRow"
            [title]="group.name"
            [viewType]="'groups'"
            [showDrilldown]="!!group.subgroups?.totalItemCount || !!group.contacts?.totalItemCount"
            [(selected)]="group.selected"
            (selectedChange)="onGroupSelected(group, $event)"
            icon="people"
            [readonly]="group.readonly"
            (drilldown)="onGroupDrilldown(group)"></li>
        }
      </ul>
      @if (group.subgroups.totalItemCount > group.subgroups.pageSize) {
        <mat-paginator
          id="group"
          [length]="group.subgroups.totalItemCount"
          [pageSize]="group.subgroups.pageSize"
          [pageIndex]="group.subgroups.page - 1"
          [hidePageSize]="true"
          (page)="onGroupPageChange($event.pageIndex + 1)">
        </mat-paginator>
      }
    </div>
  }

  <!-- Group Contacts Loading Spinner -->
  @if (group.hasIdentifier) {
    <div style="min-height: 4px">
      <app-loading
        [isCircle]="false"
        [hasLoaded]="!!group.contacts"
        [hasFailed]="loadGroupContactsFailed"
        (retryClicked)="loadGroupContacts(group)"></app-loading>
    </div>
  }
  <!-- List of group contacts -->
  @if (group.contacts && group.contacts.totalItemCount) {
    <div>
      <ul class="collection qa-contact-collection">
        @for (contact of group.contacts.items; track contact.getStableId()) {
          <li
            app-selector-row
            [title]="contact.displayName"
            [viewType]="'groups'"
            [showDrilldown]="false"
            [(selected)]="contact.selected"
            [readonly]="data?.contactsReadonly || contact.readonly"
            (selectedChange)="onContactSelected(contact, $event)"
            icon="person"></li>
        }
      </ul>
      @if (group.contacts.totalItemCount > group.contacts.pageSize) {
        <mat-paginator
          id="groupContacts"
          [length]="group.contacts.totalItemCount"
          [pageSize]="group.contacts.pageSize"
          [pageIndex]="group.contacts.page - 1"
          [hidePageSize]="true"
          (page)="onGroupContactsPageChange($event.pageIndex + 1)">
        </mat-paginator>
      }
    </div>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-button id="cancel" color="primary" cdkFocusInitial (click)="onCancelClick()">
    {{ 'Cancel' | translate: locale.language }}
  </button>
  <button mat-raised-button id="save" color="primary" (click)="onSaveClick()">
    {{ 'Save' | translate: locale.language }}
  </button>
</div>
